var map = {
	"./airbnb-logo.png": 17,
	"./behanceIcon.svg": 41,
	"./biking.png": 356,
	"./githubIcon.svg": 514,
	"./img-grid.png": 499,
	"./ishigaki.png": 385,
	"./katie.png": 714,
	"./linkedin-filled.svg": 807,
	"./star.png": 526,
	"./vatican.png": 902,
	"./wedding.png": 530
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 973;